import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoginIdResolver implements Resolve<number> {
  constructor() {}

  resolve(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    const urlSliceWithId = state.url.split('logins/').reverse()[0];
    const loginId = Number(urlSliceWithId.split('/')[0]);

    return loginId;
  }
}
